
import { useEffect, useState } from "react";
import Page from "../../Page";
import LearningPathReportHomeDetailSection from "./LearningPathReportHomeDetailSection";
import LearningPathReportHomeReaDetailSection from "./LearningPathReportHomeReaDetailSection";
import CONFIG from "../../../utils/config";


export const LearningPathReaDetailMobilePage = () => {
    // useEffect(() => {
    //     window.scrollTo(0, 0);

    //     let sendHeight = setInterval(() => {
    //         let obj = { 'method': 'height', 'value': document.body.scrollHeight }
    //         console.log('height: ', obj);
    //         if (window.callbackHandler != undefined) {
    //             window.callbackHandler.postMessage(JSON.stringify(obj));
    //         } else if (window.webkit != undefined) {
    //             if (window.webkit.messageHandlers.callbackHandler != undefined) {
    //                 window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(obj));
    //             }
    //         }

    //     }, 3000)

    //     return (() => { clearInterval(sendHeight) })

    // }, [])

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
            <LearningPathReportHomeReaDetailSection
                isMobile={true}
            />
        </>
    )
}

export default LearningPathReaDetailMobilePage;